import { formatPrice, formatSideType } from "@/lib/utils";
import { useAppSelector } from "@/redux/features/hooks";
import {
  MenuComboOrderItem,
  MenuComboOrderItemSelection,
} from "@/redux/services/order/order.type";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useRestaurantCurrency } from "@/lib/hooks";

export const ComboOrderItem: React.FC<{
  item: MenuComboOrderItem;
  currency?: string;
}> = ({ item, currency: currencyProp }) => {
  const currentRestaurant = useAppSelector(
    (state) => state.user.currentRestaurant
  );
  const hookCurrency = useRestaurantCurrency();
  const currency = currencyProp ?? hookCurrency;

  const renderSelection = (selection: MenuComboOrderItemSelection) => {
    if (selection.menuItem) {
      return (
        <ul className="list-disc pl-5 text-xs">
          <li className="">
            <span className="text-grayMedium font-medium">
              {selection.menuItem.title}
            </span>
            {selection.selectedOptions &&
              selection.selectedOptions.length > 0 && (
                <span className="text-gray-600">
                  {" "}
                  avec{" "}
                  {selection.selectedOptions
                    .map((opt: any) => opt.title)
                    .join(", ")}
                </span>
              )}
          </li>
        </ul>
      );
    }

    if (selection.sideType) {
      return (
        <ul className="list-disc pl-5 text-xs">
          <li className="">
            <span className="text-grayMedium font-medium">
              {formatSideType(selection.sideType)}
            </span>
          </li>
        </ul>
      );
    }

    return null;
  };

  return (
    <div
      className={`flex items-start gap-3 py-2 px-2 rounded-lg ${
        item.isModified ? "bg-yellow-50" : ""
      }`}
    >
      <img
        src={
          item?.menuCombo?.image?.url ??
          currentRestaurant?.image?.url ??
          "/images/icon.png"
        }
        alt={item.menuCombo.name}
        className="rounded-lg h-10 w-10 object-cover flex-shrink-0"
      />

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <div>
            <p className="text-sm font-medium text-card-foreground">
              {item.menuCombo.name}
            </p>
            <p className="text-xs mt-0.5">
              {formatPrice(item.menuCombo.price / 100, currency)}
            </p>
            {item.selections.map((selection: MenuComboOrderItemSelection) => (
              <div key={selection.id}>{renderSelection(selection)}</div>
            ))}
            {item.additionalDemands && (
              <p className="text-xs text-muted-foreground mt-0.5">
                Note: {item.additionalDemands}
              </p>
            )}
          </div>

          <div className="flex flex-col items-end flex-shrink-0">
            {item.isModified && (
              <span className="bg-yellow-200 text-yellow-800 px-1.5 py-0.5 rounded text-[10px] font-medium mb-1">
                Modifié
                {item.lastModifiedAt &&
                  ` ${format(new Date(item.lastModifiedAt), "HH'h'mm", { locale: fr })}`}
              </span>
            )}
            <span className="text-sm text-muted-foreground">
              x{item.quantity}
            </span>
            <span className="text-sm font-semibold text-card-foreground">
              {formatPrice(item.price / 100, currency)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
